// Shared helpers and constants for the Sign-Ups feature
import { toLocalDateStr } from "../../lib/date";

export const DOW = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

export const mondayOf = (date) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  const m = new Date(d.setDate(diff));
  m.setHours(0, 0, 0, 0);
  return m;
};

export const isoDate = (d) => toLocalDateStr(d);

export const weekDates = (mondayIso) => {
  const m = new Date(mondayIso + "T00:00:00");
  return Array.from({ length: 5 }, (_, i) => {
    const d = new Date(m);
    d.setDate(d.getDate() + i);
    return isoDate(d);
  });
};

export const prettyDate = (iso) => {
  try {
    return new Date(iso + "T00:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
};

export const weekLabel = (mondayIso) => {
  const m = new Date(mondayIso + "T00:00:00");
  const f = new Date(m); f.setDate(f.getDate() + 4);
  const fmt = (d) => d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  return `${fmt(m)} – ${fmt(f)}`;
};

export const lastNWeeksOptions = (n = 8) => {
  const today = new Date();
  const baseMon = mondayOf(today);
  return Array.from({ length: n }, (_, i) => {
    const d = new Date(baseMon);
    d.setDate(d.getDate() - i * 7);
    const monIso = isoDate(d);
    return { value: monIso, label: i === 0 ? `This week (${weekLabel(monIso)})` : i === 1 ? `Last week (${weekLabel(monIso)})` : weekLabel(monIso) };
  });
};

// Whether a trip pick counts as attending a specific date.
// - Explicit attend_dates -> must include the date.
// - No attend_dates + single-date trip -> that one date (legacy).
// - No attend_dates + multi-date trip -> interest only (attends no specific date),
//   so it never blocks block-class sign-ups until a date is chosen.
export const tripAttendsDate = (pick, trip, date) => {
  const attend = pick?.attend_dates;
  if (attend && attend.length) return attend.includes(date);
  const dates = (trip?.dates) || [];
  if (dates.length === 1) return date === dates[0];
  return false;
};

// Order: This week, then upcoming weeks, then past weeks.
export const weekWindowOptions = (past = 6, future = 16) => {
  const baseMon = mondayOf(new Date());
  const mk = (i) => {
    const d = new Date(baseMon);
    d.setDate(d.getDate() + i * 7);
    const monIso = isoDate(d);
    let label;
    if (i === 0) label = `This week (${weekLabel(monIso)})`;
    else if (i === 1) label = `Next week (${weekLabel(monIso)})`;
    else if (i === -1) label = `Last week (${weekLabel(monIso)})`;
    else if (i > 0) label = `In ${i} weeks (${weekLabel(monIso)})`;
    else label = `${-i} weeks ago (${weekLabel(monIso)})`;
    return { value: monIso, label };
  };
  const opts = [mk(0)];
  for (let i = 1; i <= future; i++) opts.push(mk(i));
  for (let i = 1; i <= past; i++) opts.push(mk(-i));
  return opts;
};
